import React, { ReactNode } from 'react';
import { FlexCenter } from '../FlexCenter/FlexCenter';
import { SpacingCustom } from '../Spacing/SpacingCustom';

interface IListFooterInfoProps {
    children?: ReactNode;
}

export const ListFooterInfo: React.FC<IListFooterInfoProps> = ({ children }) => {
    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
            <SpacingCustom paddingLeft={1}>
                <FlexCenter direction="v" gap={0.5}>
                    {children}
                </FlexCenter>
            </SpacingCustom>
        </div>
    );
};
